import { render, staticRenderFns } from "./loadScenario.vue?vue&type=template&id=087c0676&scoped=true&"
import script from "./loadScenario.vue?vue&type=script&lang=js&"
export * from "./loadScenario.vue?vue&type=script&lang=js&"
import style0 from "./loadScenario.vue?vue&type=style&index=0&id=087c0676&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087c0676",
  null
  
)

export default component.exports